<template>
    <!-- first section -->
   <section class="md:mt-72 flexmobile2 px-10 background-157 md:h-[440px]  max-md:mt-10 ">
        <div class="mx-auto ml-16">
          <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white pt-6 md:pt-16">Observation Study</h1>
          <h3 class="text-2xl md:text-3xl font-semibold pt-6 dancing-script text-white">Scenarios</h3>
            <ul class=" text-white pt-6 text-lg md:pb-6">
          <li class="pt-6 text-lg ">Show how you track all of the subscriptions and monitor cost</li>
          <li class="pt-6 text-lg ">Show how you would determine which subscriptions to keep and cancel</li>
          <li class="pt-6 text-lg ">Show how you would go about canceling your subscriptions</li>
          </ul>
        </div>
    </section>
    <section class=" flexmobile2 px-10 background-156 md:h-[440px]  max-md:mt-10 ">
        <div class=" mx-auto ml-16">
          <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white pt-16">Participants</h1>
            <ul class=" text-white pt-6 text-lg md:pb-6">
          <li class="pt-6 text-lg ">Recruited through word-of-mouth</li>
          <li class="pt-6 text-lg ">18+ years of age</li>
          <li class="pt-6 text-lg ">Conducted over Zoom with 6 users</li>
          <li class="pt-6 text-lg ">Screened to hold at least one subscription</li>
          <li class="pt-6 text-lg ">Carried out over 3 days</li>
          </ul>
        </div>
      </section>


  
  <!-- First Section: Text Content -->
 

  <!-- Second Section: Image Content -->
  <!-- <div class="w-full lg:w-1/2 flex items-end justify-end relative ml-120">

    <img 
      src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1727026871/American-Silver-Eagle-Bullion-BACK-min_1_jponpn.png" 
      alt="Coins Image" 
      class="w-[350px] lg:w-[385px] absolute -bottom-10 lg:bottom-0  opacity-70 z-0"
    />
  </div> -->




    <!-- secound section -->
    <section class="flex mt-32 flexmobile2  mx-auto px-10 gap-5 max-md:flex-col max-md:ml-0 max-md:px-5">
  <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726677525/Group_1929_1_zx9ovj.png" alt="" class="w-[45%] max-md:w-full max-md:mt-5">
  
  <main class="flex flexmobile2 flex-col container mx-auto w-[55%] max-md:ml-0 max-md:w-full">
    <article class="flex z-10 flex-col mt-14 max-md:mt-10 max-md:max-w-full">
      <h1 class="text-3xl md:text-4xl mt-16 font-semibold text-white">Data Collection</h1>
      <div class="mt-9 text-white pt-6 text-lg md:pb-6 max-md:max-w-full">
        <p class="pt-6 text-lg md:pb-6"><span class="text-purple-300">Platform & Consent: </span>Studies were conducted and recorded using Zoom, with verbal consent obtained from each participant.</p>
        <p class="pt-6 text-lg md:pb-6"><span class="text-purple-300">Initial Questions:</span> Participants were asked about their subscription types, duration of memberships, tracking methods, and budgeting practices.</p>
        <p class="pt-6 text-lg md:pb-6"><span class="text-purple-300">Task Walkthroughs:</span> Participants were asked to mentally or physically demonstrate tracking subscription expenses, making decisions on subscriptions, and canceling a subscription.</p>
        <p class="pt-6 text-lg md:pb-6"><span class="text-purple-300">Screen Sharing:</span> For the cancelation task, participants were encouraged to demonstrate; however, most opted to verbally describe the process due to the sensitive nature of financial information.</p>
        <p class="pt-6 text-lg md:pb-6"><span class="text-purple-300">Follow-Up Questions:</span> Additional questions were asked to explore participants' challenges and desires related to subscription management.</p>
      </div>
    </article>
  </main>
</section>

    <!-- third section  -->
    <section class=" mx-auto mt-44 px-20 max-md:ml-0 max-md:mt-10 max-md:px-5">
  <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white">Participant Spectrums</h1>
  <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726677594/Group_1925_ssuzp7.png" alt="" class="w-full max-md:mt-5 object-contain">
</section>

    <!-- fourth section -->
    <section class=" mx-auto mt-44 px-20 max-md:ml-0 max-md:mt-10 max-md:px-5">
  <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white">Affinity Diagram from Interviews</h1>
  <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726677677/Group_1929_2_ij2tww.png" alt="" class="w-full max-md:mt-5 object-contain">
</section>


     <!-- section five -->
     <section class="flex flex-col items-center px-10 py-10 max-md:px-5">
  <!-- Top Findings Title -->
  <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white">Top Findings</h1>

  <!-- Decision-Making Icon -->
  <div class="flex flex-col items-center text-white mb-20 max-md:mb-10">
    <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/2f25404ef9c293bb51139ded7b593ef901d41eb67f29bc40961ee64475a45aa9?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Illustration" class="w-72 h-72 mb-4 max-md:w-56 max-md:h-56">
    <p class="text-2xl md:text-3xl font-semibold pt-6 dancing-script ">Decision-Making</p>
  </div>

  <!-- Findings Lists -->
  <div class="flex flex-wrap justify-around gap-10 text-white text-lg w-full max-w-full max-md:gap-6">
    <!-- Usage Patterns -->
    <div class="flex flex-col items-center text-center max-md:w-full">
      <p class="text-xl lavender-color font-semibold mb-2">USAGE PATTERNS</p>
      <ol class="pt-6 text-lg md:pb-6 list-disc  max-md:text-base">
        <li>High: Daily, weekly</li>
        <li>Low: Monthly, sporadic</li>
      </ol>
    </div>

    <!-- Perceived Value & Need -->
    <div class="flex flex-col items-center text-center max-md:w-full">
      <p class="text-xl lavender-color font-semibold mb-2">PERCEIVED VALUE & NEED</p>
      <ol class="pt-6 text-lg md:pb-6 list-disc  max-md:text-base">
        <li>Novelty & Context</li>
        <li>Connection & Growth</li>
      </ol>
    </div>

    <!-- Budgeting -->
    <div class="flex flex-col items-center text-center max-md:w-full">
      <p class="text-xl font-semibold lavender-color mb-2">BUDGETING</p>
      <p class="pt-6 text-lg  ">Mixed-Method Approach:</p>
      <ol class=" list-disc pt-6 text-lg md:pb-6  max-md:text-base">
        <li>Bank Statements</li>
        <li>Credit Cards</li>
      </ol>
    </div>
  </div>

  <!-- Second Row: Bottom Icons -->
  <div class="flex flex-wrap justify-around gap-10 mt-32 w-full max-md:gap-6 max-md:mt-20">
    <!-- Icon and List 1 -->
    <div class="flex flex-col items-center max-md:w-full">
      <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/c030669c98bcd85afa8afb5195ee832dfcbb71d7e86134eac012c4a387d9af6f?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Illustration" class="w-44 h-44 max-md:w-32 max-md:h-32">
      <p class="text-2xl md:text-3xl font-semibold pt-6 dancing-script text-white">Tracking</p>
      <p class="pt-6 text-lg md:pb-6  text-white ">Most use a combined approach:</p>
      <ol class=" text-white list-disc pt-6 text-lg md:pb-6  max-md:text-base">
        <li>Spreadsheets</li>
        <li>Bank statements</li>
        <li>App</li>
        <li>Mentally tracking</li>
      </ol>
       <ul class=" text-white text-lg md:pb-6  max-md:text-base">
        <li>Shared use</li>
        <li>Intentionally avoids tracking</li>
      </ul>
    </div>

    <!-- Icon and List 2 -->
    <div class="flex flex-col items-center max-md:w-full">
      <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/7090f67ba1ead9ed592163e72f740ea0eac0d3b750616b2f81bbbe339ccb2131?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Illustration" class="w-44 h-44 max-md:w-32 max-md:h-32">
      <p class="text-2xl md:text-3xl font-semibold pt-6 dancing-script text-white">Cancellation</p>
      <p class="pt-6 text-lg md:pb-6 text-white ">Experiences with friction</p>
      <ol class=" pt-6 text-lg md:pb-6 text-white  list-disc  max-md:text-base">
        <li>Broken-flows</li>
        <li>Dark design patterns</li>
        <li>Frustrating & hard</li>
      </ol>
    </div>
  </div>
</section>


    </template>
  
  <script>
  export default {
    name: 'SecoundSubSection'
  }
  </script>

<style>
.background-159 {
  background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1727022920/Group_34249_ya49s9.png");
  background-size: cover; /* Ensures the image covers the entire background */
  background-position: center; /* Centers the background image */
  
}
@media (max-width:640px) {
  .background-158 {
  background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726677799/Group_1928_1_qslsuc.png");
  background-size: cover; /* Ensures the image covers the entire background */
  background-position: center; /* Centers the background image */
  background-repeat: no-repeat; /* Prevents the image from repeating */
  height:1200px; /* Ensures the div takes up the full height of its container */
  width: 100%; 
}
}

</style>

